const pressForm = document.querySelector(".js-checkbox");

if (typeof pressForm != "undefined" && pressForm != null) {
    const pressCheck = document.querySelector(".press-access__checkbox");

    pressCheck.addEventListener("click", function (event) {
        if (pressCheck.checked) {
        pressForm.classList.add("is-checked");
        } else {
            pressForm.classList.remove("is-checked");
        }
    });

    document.addEventListener( 'wpcf7mailsent', function( event ) {
        location = 'https://seemonster.co.uk/press-access/press-release/';
      }, false );
}
